<div
  class="min-h-screen"
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
>
  <app-block-list [blockIdList]="body"></app-block-list>
</div>
